import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
    window.addEventListener('DOMContentLoaded', function () {

        // タッチデバイスかどうかを確認
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        const splideElements = document.getElementsByClassName('splide');

        for (let i = 0; i < splideElements.length; i++) {
            new Splide(splideElements[i]).mount();
        }

        const service02SlideElements = document.querySelectorAll('.js-voice-slide');
        service02SlideElements.forEach(element => {
            new Splide(element, {
                type: 'loop',
                gap: '1.5rem',
                perPage: 1,
                fixedWidth: '47.5rem',
                breakpoints: {
                    768: {
                        gap: '0rem',
                        fixedWidth: '100%',
                        arrows: true,
                speed: 500,
                perPage: 1, 
                    },
                },
                arrows: true, // 矢印の有効化
                autoplay: !isTouchDevice, // タッチデバイスでは自動再生を無効にする
                pauseOnHover: false,
                pauseOnFocus: false,
                focus: 'center',
                interval: 4000,
                speed: 2000,
                pagination: true,  // ページネーションを有効化
                classes: {
                    pagination: 'splide__pagination p-voice__pagination',
                    page: 'splide__pagination__page p-voice__page',
                },
            }).mount();
        });

        // 縦方向のスクロールを許可するためのイベントリスナーを追加
        const slides = document.querySelectorAll('.splide__slide');
        slides.forEach(slide => {
            slide.addEventListener('touchstart', function(e) {
                e.stopPropagation();
            });
        });
    });
}
